import * as React from "react";
import { useCallback, useEffect } from "react";
import { styled } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { RosebudColorMap } from "../../diagnosticAgent/rosebud/rosebudColorMap";
import {
  ACTION,
  CATEGORY,
  evt,
  setUserForAnalytics,
} from "fe-common/analytics/analytics";
import { LoginWidget } from "user-management/src/components/loginWidget";

//region [[ Styles ]]
const UserLoginView = styled("div")({
  position: "absolute",
  width: "100%",
  height: "100%",
  background: RosebudColorMap.mainBackground,
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
});

const Login = styled(LoginWidget)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  marginTop: theme.spacing(1),
  background: "white",
}));
//endregion [[ Styles ]]

export const LoginPage = () => {
  const history = useHistory();
  const location = useLocation();
  const useQuery = () => new URLSearchParams(location.search);
  const query = useQuery();

  useEffect(() => {
    evt({
      category: CATEGORY.GENERAL_UX,
      action: ACTION.LOG_IN,
      label: "page enter",
    });
  }, []);

  const { search } = location;
  const handleSignIn = useCallback(
    (email: string) => {
      const partner = query.get("pid");
      setUserForAnalytics(email, partner ? { partner } : {});
      if (query.get("nextUrl")) {
        history.push({
          pathname: decodeURIComponent(query.get("nextUrl")),
          search,
        });
      } else {
        history.push({ pathname: "/agent", search });
      }
    },
    [search, query, history],
  );

  const handleForgotPassword = useCallback(() => history.push("newpassword"), [
    history,
  ]);

  const handleSignUpClick = useCallback(
    () => history.push({ pathname: "signup", search: location.search }),
    [history, location],
  );

  return (
    <UserLoginView>
      <Login
        onForgotPasswordClick={handleForgotPassword}
        onSignUpClick={handleSignUpClick}
        onSignIn={handleSignIn}
      />
    </UserLoginView>
  );
};
